export enum BookingStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  ARCHIVED = 'archived',
}

export enum BookingPaymentStatus {
  UNPAID = 'unpaid',
  PARTIALLY_PAID = 'partially_paid',
  PAID = 'paid',
  REFUNDED = 'refunded',
}

export enum TravellerAgeCategory {
  ADULT = 'adult',
  CHILD = 'child',
  INFANT = 'infant',
}

export interface BookingItem {
  id: string;
  resourceId: string;
  resourceName: string;
  description?: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  discountPercent: number;
  discountAmount: number;
  startDate: string;
  endDate: string;
}

export interface Traveller {
  id: string;
  title?: string;
  firstName: string;
  lastName: string;
  name: string;
  email?: string;
  phone?: string;
  passportNumber?: string;
  dateOfBirth?: string;
  ageCategory: TravellerAgeCategory;
}

export interface BookingCustomer {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
}

export interface Booking {
  id: string;
  bookingNumber: string;
  customerId: string;
  agentId?: string;
  status: BookingStatus;
  paymentStatus: BookingPaymentStatus;
  startDate: string;
  endDate: string;
  subtotal: number;
  taxes: number;
  discountAmount: number;
  totalAmount: number;
  discountPercent: number;
  notes?: string[];
  items: BookingItem[];
  travellers?: Traveller[];
  description?: string;
  createdAt: string;
  updatedAt: string;
  confirmedAt?: string;
  cancelledAt?: string;
  completedAt?: string;
  customer?: BookingCustomer;
  agent?: BookingCustomer;
}

export interface BookingListResponse {
  status: string;
  code: number;
  message: string;
  meta: {
    total_records: number;
    current_page: number;
    page_size: number;
    total_pages: number;
    sort_by: string;
    sort_dir: string;
  };
  data: Booking[];
}

export interface BookingResponse {
  status: string;
  code: number;
  message: string;
  data: Booking;
}

export interface BookingStatistics {
  totalBookings: number;
  confirmedBookings: number;
  pendingBookings: number;
  cancelledBookings: number;
  completedBookings: number;
  totalRevenue: number;
  averageBookingValue: number;
}

export const BOOKING_STATUSES = [
  { label: 'Draft', value: BookingStatus.DRAFT, color: 'gray' },
  { label: 'Pending', value: BookingStatus.PENDING, color: 'yellow' },
  { label: 'Confirmed', value: BookingStatus.CONFIRMED, color: 'green' },
  { label: 'Cancelled', value: BookingStatus.CANCELLED, color: 'red' },
  { label: 'Completed', value: BookingStatus.COMPLETED, color: 'blue' },
  { label: 'Archived', value: BookingStatus.ARCHIVED, color: 'gray' },
];

export const BOOKING_PAYMENT_STATUSES = [
  { label: 'Unpaid', value: BookingPaymentStatus.UNPAID, color: 'red' },
  { label: 'Partially Paid', value: BookingPaymentStatus.PARTIALLY_PAID, color: 'yellow' },
  { label: 'Paid', value: BookingPaymentStatus.PAID, color: 'green' },
  { label: 'Refunded', value: BookingPaymentStatus.REFUNDED, color: 'gray' },
];

export enum PaymentMethod {
  CREDIT_CARD = 'credit_card',
  DEBIT_CARD = 'debit_card',
  CASH = 'cash',
  BANK_TRANSFER = 'bank_transfer',
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
}

export const PAYMENT_METHODS = [
  { label: 'Credit Card', value: PaymentMethod.CREDIT_CARD },
  { label: 'Debit Card', value: PaymentMethod.DEBIT_CARD },
  { label: 'Cash', value: PaymentMethod.CASH },
  { label: 'Bank Transfer', value: PaymentMethod.BANK_TRANSFER },
  { label: 'PayPal', value: PaymentMethod.PAYPAL },
  { label: 'Stripe', value: PaymentMethod.STRIPE },
];
